import * as React from "react";
import * as AuthStore from "../store/Auth";
import * as moment from 'moment';
import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import * as Highcharts from 'highcharts';
import { postQuery } from '../utils';
import { Button, Select, Card, DatePicker, message, Row, Col, Tabs } from 'antd';
import { ReloadOutlined, LineChartOutlined, OrderedListOutlined } from '@ant-design/icons/lib';
import { busyGif } from '../img';
import { exit } from "process";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Mer extends React.Component<AuthProps>
{
    public state =
    {
        data: [],
        lineList: [],
        stateList: [],
        siteList: [],
        activeKey: 1,
        txNewData: [],
        txNewLineList: [],
        patients: 0,
        txNew: [],
        fileUrl: '',
        pagination:
        {
            current: 1,
            total: 0,
            pageSize: 100,
            sorter: {
                field: "name",
                order: "asc"
            }
        },
        clientSite: false,
        statesLoaded: true,
        siteId: 0,
        asset: '',
        assetName: '',
        regimens: [],
        loading: false,
            txData: { tested: 0, suppressed: 0, unsuppressed: 0, indexClients: 0, anc: 0, totalPbs: 0, pbsFemales: 0, pbsMales: 0, totalTxNew: 0, txNewFemales: 0, txNewMales: 0, females: 0, males: 0, total: 0, inactive: 0, stateStats: [], groupCounts: [], positive: 0, negative: 0, totalManifests: 0, totalSamples: 0, rejectedSamples: 0, samplesWithResult: 0},
        confirmLoading: false,
        site: { id: 0, name: '', stateName: '', stateCode: '', stateId: '' },
        state: { stateId: 0, stateName: '', stateCode: '', sites: [] },            
        searchText: "",
        visible: false,
        selected: false,
        states: [],
        activeTab: 1,
        sites: [],
        searchObj:
        {
            from: '',
            to: '',
            stateId: 0,
            state: '',
            site: 0,
            siteId: '',
            siteName: '',
            stateName: '',
            itemsPerPage: 0,
            pageNumber: 0,
            indicator: '',
            ageBand: ''
         },
        tHeads: [],
        tBody: [],
        showingInfoWindow: false,
        selectedPlace: {name: ''}
    };

    onInfoWindowClose(props) {
        if (this.state.showingInfoWindow)
        {
            this.setState({
                showingInfoWindow: false
            });
        }
    };
    
    tabChanged = (activeKey: any) => this.setState({ activeKey });    

    //async getData()
    //{
    //    const { searchObj } = this.state;

    //    if (searchObj.indicator.length < 1)
    //    {
    //        message.error("Please select an indicator");
    //        return;
    //    }

    //    let url = '/api/Stats/';

    //    if (searchObj.indicator === 'TX_CURR')
    //    {
    //        url += 'getTxCurr';
    //    }
    //    if (searchObj.indicator === 'TX_RTT')
    //    {
    //        url += 'getTXRTT';
    //    }
    //    if (searchObj.indicator === 'TX_NEW')
    //    {
    //        url += 'getTXNEW';
    //    }
    //    if (searchObj.indicator === 'TX_ML')
    //    {
    //        url += 'getTXML';
    //    }
    //    if (searchObj.indicator === 'TX_PVLS')
    //    {
    //        url += 'getTXPVLS';
    //    }

    //    this.setState({ loading: true });

    //    let data = await postQuery(url, JSON.stringify(searchObj));
        
    //    this.setState({ loading: false });

    //    //if (data && data.lenght > 0)
      //    //{
    //    //    console.log(data);
    //        this.setState({ data });
    //    //}
    //}

    selectIndicator(value: any)
    {
        const { searchObj } = this.state;
        searchObj.indicator = value.key;
        this.setState({ fileUrl: '' });
        this.setState({ searchObj, asset: '', assetName: '', txData: { tested: 0, suppressed: 0, unsuppressed: 0, indexClients: 0, anc: 0, totalPbs: 0, pbsFemales: 0, pbsMales: 0, totalTxNew: 0, txNewFemales: 0, txNewMales: 0, females: 0, males: 0, inactive: 0, total: 0, positive: 0, negative: 0, stateStats: [], groupCounts: [], totalManifests: 0, totalSamples: 0, rejectedSamples: 0, samplesWithResult: 0 } });
        document.getElementById('band').innerHTML = '';
        document.getElementById('hts_results').innerHTML = '';
        document.getElementById('hts_session').innerHTML = '';
        document.getElementById('hts_settings').innerHTML = '';
        document.getElementById('pbs').innerHTML = '';
        document.getElementById('pvls').innerHTML = '';
        document.getElementById('pmtct_hts').innerHTML = '';
        document.getElementById('pmtct_hts_entry').innerHTML = '';
    }     

    //selectAgeBand(value: any)
    //{
    //    const { searchObj } = this.state;
    //    searchObj.ageBand = value.key;
    //    this.setState({ searchObj });
    //} 

    async componentDidMount()
    {    
        let el = this;

        //let sttx = localStorage.getItem("stateNames");
        //if (sttx) {
        //    this.setState({ stateX: JSON.parse(sttx) })
        //}

        let user = el.props.appUser;     
        let sts = localStorage.getItem("states");
        let states = [];    
        if (sts) states = JSON.parse(sts);

        if (user.stateId && user.stateId > 0)
        {
            var statex = states.filter(function (s: any) {return s.stateId === user.stateId });
            if (statex.length > 0)
            {
                let { searchObj } = this.state;
                let state: any = statex[0];
                searchObj.stateName = state.stateName;
                searchObj.stateId = state.stateId;
                el.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        el.setState({ states, statesLoaded });
        var comlumHeadrs =
            [
                "State",
                "LGA",
                "FacilityId",
                "FacilityName",
                "PatientId",
                "PatientHospitalNo",
                "Sex",
                "DOB",
                "CurrentAge",
                "CurrentAgeInMonths",
                "ARTStartDate",
                "AgeAtStartOfArtInYears",
                "AgeAtStartOfArtInMonths",
                "LastClinicVisitDate",
                "ClinicNextAppointmentDate",
                "FirstRegimenLine",
                "FirstRegimen",
                "LastDrugPickupDate",
                "DaysOfARVRefill",
                "CurrentRegimenLine",
                "CurrentRegimen",
                "PregnancyStatus",
                "SampleCollectionDate",
                "ViralLoad",
                "ViralLoadResultDate",
                "viralLoadIndication",
                "TreatmentOutcome",
                "status28",
                "status90",
                "TransferredIn",
                "EducationalLevel",
                "MaritalStatus",
                "JobStatus",
                "weight",
                "BP",
                "WhoStage"
            ];
        this.setState({ tHeads: comlumHeadrs });  
    }

    dateRangeChange(a: any[], dateString: any)
    {    
        let from = '';
        let to = '';
        if (dateString && dateString[0])
        {
            from = dateString[0];
        }
        else
        {
            from = '';
        }

        if (dateString && dateString[1])
        {
            to = dateString[1];
        }
        else
        {
            from = '';
        }
        const { searchObj } = this.state;
        searchObj.from = from;
        searchObj.to = to;        
        this.setState({ searchObj });        
    }

    dateChange(date: any, dateString: any)
    {
        let to = '';      
        if (dateString)
        {
            to = dateString;
        }
        const { searchObj } = this.state;
        searchObj.to = to;
        this.setState({ searchObj });
    }

    selectSite(value: any)
    {
        const { searchObj } = this.state;
        if (value)
        {
            searchObj.site = value.key;
            searchObj.siteId = value.key;
            let sites: any = this.state.state.sites.filter(function (o: any) { return o.id === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj });  
        } 
    }

    selectState(value: any)
    {
        if (!value)
        {
            return;
        }

        const { searchObj } = this.state;          
        searchObj.site = 0;
        if (value)
        {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0)
            {
                var state = states[0];
                //state.sites = states[0].sites;
                searchObj.stateName = state.stateName;
                searchObj.stateId = state.stateId;
                searchObj.state = state.stateCode;
                this.setState({ state: state, searchObj: searchObj });
            } 
        }        
    }

    reset()
    {           
        this.setState({
            searchObj:
            {
                from: '',
                to: '',
                stateId: 0,
                state: '',
                site: 0,
                siteId: 0,
                siteName: '',
                stateName: '',
                itemsPerPage: 0,
                pageNumber: 0,
                indicator: '',
                ageBand: ''
            },
            asset: '', assetName: '', txData: { tested: 0, suppressed: 0, unsuppressed: 0, indexClients: 0, anc: 0, totalPbs: 0, pbsFemales: 0, pbsMales: 0, totalTxNew: 0, txNewFemales: 0, txNewMales: 0, females: 0, males: 0, inactive: 0, total: 0, stateStats: [], positive: 0, negative: 0, groupCounts: [], totalManifests: 0, totalSamples: 0, rejectedSamples: 0, samplesWithResult: 0 }});
        document.getElementById('band').innerHTML = '';
        document.getElementById('hts_results').innerHTML = '';
        document.getElementById('hts_session').innerHTML = '';
        document.getElementById('hts_settings').innerHTML = '';
        document.getElementById('pbs').innerHTML = '';
        document.getElementById('pvls').innerHTML = '';
        document.getElementById('pmtct_hts').innerHTML = '';
        document.getElementById('pmtct_hts_entry').innerHTML = '';  
    }

    setTab(e)
    {
        this.reset();
        this.setState({ activeTab: e});
    }

    async qQ()
    {
        let el = this;
        let user = el.props.appUser;
        el.setState({ fileUrl: '' });
        el.setState({ asset: '', assetName: '', txData: { tested: 0, suppressed: 0, unsuppressed: 0, indexClients: 0, anc: 0, totalPbs: 0, pbsFemales: 0, pbsMales: 0, totalTxNew: 0, txNewFemales: 0, txNewMales: 0, females: 0, males: 0, inactive: 0, total: 0, positive: 0, negative: 0, stateStats: [], groupCounts: [], totalManifests: 0, totalSamples: 0, rejectedSamples: 0, samplesWithResult: 0 } });
        document.getElementById('band').innerHTML = '';
        document.getElementById('hts_results').innerHTML = '';
        document.getElementById('hts_session').innerHTML = '';
        document.getElementById('hts_settings').innerHTML = '';
        document.getElementById('pbs').innerHTML = '';
        document.getElementById('pvls').innerHTML = '';
        document.getElementById('pmtct_hts').innerHTML = '';
        document.getElementById('pmtct_hts_entry').innerHTML = '';      
         
        const { searchObj } = el.state;

        if (searchObj.indicator.length < 1)
        {
            message.error("Please select an indicator");
            return;
        }
      
        if (searchObj.indicator !== 'TX_CURR' && searchObj.indicator !== 'TX_CURR_STAT' && searchObj.indicator !== 'LineList'
            && searchObj.indicator !== 'TX_NEW_STAT' && searchObj.indicator !== 'TX_NEW'
        )
        {
            if(el.state.searchObj.from.length < 1)
            {
                message.error("Please select a Date Range");
                return;
            }
            if (el.state.searchObj.to.length < 1)
            {
                message.error("Please select a Date range");
                return;
            }
        }

        let payload =
        {
            from: el.state.searchObj.from,
            to: el.state.searchObj.to,
            itemsPerPage: 50,
            pageNumber: 1,
            ageBand: searchObj.ageBand ? searchObj.ageBand : 0,
            site: searchObj.site ? searchObj.site : 0,
            siteId: searchObj.siteId ? searchObj.siteId : 0,
            indicator: searchObj.indicator,
            state: (user.stateCode && user.stateCode.length > 0) ? user.stateCode : searchObj.state,
            siteName: searchObj.siteName,
            stateName: searchObj.stateName,
            stateId: searchObj.stateId ? searchObj.stateId : 0
        }
       
        let s = JSON.stringify(payload);

        el.setState({ loading: true });

        let res = el.state.activeTab == 1 ? await postQuery('/api/Stats/getTxStat', s) : await postQuery('/api/Stats/fetchIndicatorData', s);        
        el.setState({ loading: false });

        console.log(res);

        if (res.code < 1) 
        {   
            message.error(res.message);
        }
        else
        {      
            if (el.state.activeTab == 2)
            {
                // console.log("Indicators Tab");
                let fUrl = '/api/Stats/getFile?baseF=' + res.asset + '&filename=' + res.fileName;
                el.setState({ loading: false, fileUrl: fUrl });
                // console.log(fUrl);
                // return;
            }
            if (el.state.activeTab == 1)
            {
                el.setState({ txData: res });

                if (searchObj.indicator === "HTS_STAT")
                {
                    if (res.htsStats && res.htsStats.length > 0)
                    {
                        var stats = [];
                        var tested = 0;
                        var positive = 0;
                        var negative = 0;
                        var indexClients = 0;
                        //@ts-ignore
                        if ((el.state.searchObj.stateId > 0 && el.state.searchObj.siteId < 1))
                        {
                            res.htsStats.map(function (hts)
                            {
                                let statsx = stats.filter(function (s: any) { return s.stateCode === el.state.state.stateCode });
                                if (statsx && statsx.length > 0)
                                {
                                    statsx[0].outreach += hts.outreach;
                                    statsx[0].standaloneHTS += hts.standaloneHTS;
                                    statsx[0].communityART += hts.communityART;
                                    statsx[0].negative += hts.negative;
                                    statsx[0].vct += hts.vct;
                                    statsx[0].tb += hts.tb;
                                    statsx[0].sti += hts.sti;
                                    statsx[0].opd += hts.opd;
                                    statsx[0].fp += hts.fp;
                                    statsx[0].ward += hts.ward;
                                    statsx[0].individual += hts.individual;
                                    statsx[0].couple += hts.couple;
                                    statsx[0].selfTested += hts.selfTested;
                                    statsx[0].indexClient += hts.indexClient;
                                    statsx[0].nonIndexClient += hts.nonIndexClient;
                                    statsx[0].positive += hts.positive;
                                    statsx[0].totalTested += hts.totalTested;
                                    statsx[0].voluntary += hts.voluntary;
                                    statsx[0].pitc += hts.pitc;
                                    statsx[0].others += hts.others;

                                    tested += hts.totalTested;
                                    positive += hts.positive;
                                    negative += hts.negative;
                                    indexClients += hts.indexClient;
                                }
                                else
                                {
                                    hts.stateCode = el.state.state.stateCode;
                                    hts.stateName = el.state.state.stateName;
                                    tested += hts.totalTested;
                                    positive += hts.positive;
                                    negative += hts.negative;
                                    indexClients += hts.indexClient;
                                    stats.push(hts);
                                }
                            });
                        }
                        //@ts-ignore
                        else if (el.state.searchObj.stateId < 1 && el.state.searchObj.siteId < 1)
                        {
                            var sites = [];

                            el.state.states.map(function (s: any)
                            {
                                //let states = el.state.stateX.filter(function (s: any) { return s.code === s.sat }); 
                                sites = sites.concat(s.sites);
                            });

                            res.htsStats.map(function (hts)
                            {
                                let stitesx = sites.filter(function (s: any) { return s.siteId === hts.siteId });
                                var stitex = stitesx[0];
                                let statsx = stats.filter(function (s: any) { return s.stateCode === stitex.stateCode });
                                if (statsx && statsx.length > 0)
                                {
                                    statsx[0].outreach += hts.outreach;
                                    statsx[0].standaloneHTS += hts.standaloneHTS;
                                    statsx[0].communityART += hts.communityART;
                                    statsx[0].negative += hts.negative;
                                    statsx[0].vct += hts.vct;
                                    statsx[0].tb += hts.tb;
                                    statsx[0].sti += hts.sti;
                                    statsx[0].opd += hts.opd;
                                    statsx[0].fp += hts.fp;
                                    statsx[0].ward += hts.ward;
                                    statsx[0].individual += hts.individual;
                                    statsx[0].couple += hts.couple;
                                    statsx[0].selfTested += hts.selfTested;
                                    statsx[0].indexClient += hts.indexClient;
                                    statsx[0].nonIndexClient += hts.nonIndexClient;
                                    statsx[0].positive += hts.positive;
                                    statsx[0].totalTested += hts.totalTested;
                                    statsx[0].voluntary += hts.voluntary;
                                    statsx[0].pitc += hts.pitc;
                                    statsx[0].others += hts.others;

                                    tested += hts.totalTested;
                                    positive += hts.positive;
                                    negative += hts.negative;
                                    indexClients += hts.indexClient;
                                }
                                else
                                {
                                    hts.stateCode = stitex.stateCode;
                                    hts.stateName = stitex.stateName;
                                    tested += hts.totalTested;
                                    positive += hts.positive;
                                    negative += hts.negative;
                                    indexClients += hts.indexClient;
                                    stats.push(hts);
                                }
                            });
                        }
                        //@ts-ignore
                        else if (el.state.searchObj.siteId > 0)
                        {
                            res.htsStats.map(function (hts)
                            {
                                hts.stateCode = el.state.state.stateCode;
                                hts.stateName = el.state.state.stateName;
                                tested += hts.totalTested;
                                positive += hts.positive;
                                negative += hts.negative;
                                indexClients += hts.indexClient;
                                stats.push(hts);
                            });
                        }

                        var txData = el.state.txData;
                        txData.tested = tested;
                        txData.positive = positive;
                        txData.negative = negative
                        txData.indexClients = indexClients;
                        el.setState({ txData });
                        el.plotHtsResult(stats);
                    }                     
                }
                else if (searchObj.indicator === "PMTCT_HTS_STAT")
                {
                    if (res.htsStats && res.htsStats.length > 0)
                    {
                        var stats = [];
                        var tested = 0;
                        var positive = 0;
                        var negative = 0;

                        //@ts-ignore
                        if ((el.state.searchObj.stateId > 0 && el.state.searchObj.siteId < 1)) {
                            res.htsStats.map(function (hts) {
                                let statsx = stats.filter(function (s: any) { return s.stateCode === el.state.state.stateCode });
                                if (statsx && statsx.length > 0) {
                                    statsx[0].negative += hts.negative;
                                    statsx[0].labourAndDelivery += hts.labourAndDelivery;
                                    statsx[0].postnatalWard += hts.postnatalWard;
                                    statsx[0].positive += hts.positive;
                                    statsx[0].totalTested += hts.totalTested;

                                    tested += hts.totalTested;
                                    positive += hts.positive;
                                    negative += hts.negative;
                                }
                                else {
                                    hts.stateCode = el.state.state.stateCode;
                                    hts.stateName = el.state.state.stateName;
                                    tested += hts.totalTested;
                                    positive += hts.positive;
                                    negative += hts.negative;
                                    stats.push(hts);
                                }
                            });
                        }
                        //@ts-ignore
                        else if (el.state.searchObj.stateId < 1 && el.state.searchObj.siteId < 1) {
                            var sites = [];

                            el.state.states.map(function (s: any) {
                                //let states = el.state.stateX.filter(function (s: any) { return s.code === s.sat }); 
                                sites = sites.concat(s.sites);
                            });

                            res.htsStats.map(function (hts)
                            {
                                let stitesx = sites.filter(function (s: any) { return s.siteId === hts.siteId });
                                var stitex = stitesx[0];
                                let statsx = stats.filter(function (s: any) { return s.stateCode === stitex.stateCode });
                                if (statsx && statsx.length > 0) {
                                    statsx[0].negative += hts.negative;
                                    statsx[0].labourAndDelivery += hts.labourAndDelivery;
                                    statsx[0].postnatalWard += hts.postnatalWard;
                                    statsx[0].positive += hts.positive;
                                    statsx[0].totalTested += hts.totalTested;

                                    tested += hts.totalTested;
                                    positive += hts.positive;
                                    negative += hts.negative;
                                }
                                else
                                {
                                    hts.stateCode = stitex.stateCode;
                                    hts.stateName = stitex.stateName;
                                    tested += hts.totalTested;
                                    positive += hts.positive;
                                    negative += hts.negative;
                                    stats.push(hts);
                                }
                            });
                        }
                        //@ts-ignore
                        else if (el.state.searchObj.siteId > 0)
                        {
                            res.htsStats.map(function (hts)
                            {
                                hts.stateCode = el.state.state.stateCode;
                                hts.stateName = el.state.state.stateName;
                                tested += hts.totalTested;
                                positive += hts.positive;
                                negative += hts.negative;
                                stats.push(hts);
                            });
                        }

                        var txData = el.state.txData;
                        txData.tested = tested;
                        txData.positive = positive;
                        txData.negative = negative
                        el.setState({ txData });
                        el.plotPmtctHtsResult(stats);
                    }
                }
                else if (searchObj.indicator === "TX_PVLS_STAT")
                {
                    if (res.lineCounts && res.lineCounts.length > 0)
                    {
                        var stats = [];
                        //@ts-ignore
                        if ((el.state.searchObj.stateId > 0 && el.state.searchObj.siteId < 1))
                        {
                            res.lineCounts.map(function (pvls)
                            {
                                let statsx = stats.filter(function (s: any) { return s.stateCode === el.state.state.stateCode });
                                if (statsx && statsx.length > 0)
                                {
                                    statsx[0].total += pvls.total;
                                    statsx[0].aggregator1 += pvls.aggregator1;
                                    statsx[0].aggregator2 += pvls.aggregator2;

                                }
                                else {
                                    pvls.stateCode = el.state.state.stateCode;
                                    pvls.stateName = el.state.state.stateName;                                    
                                    stats.push(pvls);
                                }
                            });
                        }
                        //@ts-ignore
                        else if (el.state.searchObj.stateId < 1 && el.state.searchObj.siteId < 1) {
                            var sites = [];

                            el.state.states.map(function (s: any) {
                                //let states = el.state.stateX.filter(function (s: any) { return s.code === s.sat }); 
                                sites = sites.concat(s.sites);
                            });

                            res.lineCounts.map(function (pvls) {
                                let stitesx = sites.filter(function (s: any) { return s.siteId === pvls.siteId });
                                var stitex = stitesx[0];
                                let statsx = stats.filter(function (s: any) { return s.stateCode === stitex.stateCode });
                                if (statsx && statsx.length > 0) {
                                    statsx[0].total += pvls.total;
                                    statsx[0].aggregator1 += pvls.aggregator1;
                                    statsx[0].aggregator2 += pvls.aggregator2;
                                }
                                else
                                {
                                    pvls.stateCode = stitex.stateCode;
                                    pvls.stateName = stitex.stateName;                                    
                                    stats.push(pvls);
                                }
                            });
                        }
                        //@ts-ignore
                        else if (el.state.searchObj.siteId > 0)
                        {
                            res.lineCounts.map(function (pvls)
                            {
                                pvls.stateCode = el.state.state.stateCode;
                                pvls.stateName = el.state.state.stateName;                                
                                stats.push(pvls);
                            });
                        }

                        el.setState({ txData: res });
                        el.plotPvls(stats);
                        if (res.groupCounts) el.plotAgeBand(res.groupCounts);
                    }

                }
                else if (searchObj.indicator === "TX_PBS_STAT")
                {
                    if (res.lineCounts && res.lineCounts.length > 0)
                    {
                        var stats = [];
                        
                        //@ts-ignore
                        if ((el.state.searchObj.stateId > 0 && el.state.searchObj.siteId < 1))
                        {
                            res.lineCounts.map(function (pbs)
                            {
                                let statsx = stats.filter(function (s: any) { return s.stateCode === el.state.state.stateCode });
                                if (statsx && statsx.length > 0)
                                {
                                    statsx[0].total += pbs.total;
                                    statsx[0].aggregator1 += pbs.aggregator1;
                                    statsx[0].aggregator2 += pbs.aggregator2;

                                }
                                else
                                {
                                    pbs.stateCode = el.state.state.stateCode;
                                    pbs.stateName = el.state.state.stateName;
                                    stats.push(pbs);
                                }
                            });
                        }
                        //@ts-ignore
                        else if (el.state.searchObj.stateId < 1 && el.state.searchObj.siteId < 1) {
                            var sites = [];

                            el.state.states.map(function (s: any) {
                                //let states = el.state.stateX.filter(function (s: any) { return s.code === s.sat }); 
                                sites = sites.concat(s.sites);
                            });

                            res.lineCounts.map(function (pbs) {
                                let stitesx = sites.filter(function (s: any) { return s.siteId === pbs.siteId });
                                var stitex = stitesx[0];
                                let statsx = stats.filter(function (s: any) { return s.stateCode === stitex.stateCode });
                                if (statsx && statsx.length > 0) {
                                    statsx[0].total += pbs.total;
                                    statsx[0].aggregator1 += pbs.aggregator1;
                                    statsx[0].aggregator2 += pbs.aggregator2;
                                }
                                else {
                                    pbs.stateCode = stitex.stateCode;
                                    pbs.stateName = stitex.stateName;
                                    stats.push(pbs);
                                }
                            });
                        }
                        //@ts-ignore
                        else if (el.state.searchObj.siteId > 0)
                        {
                            res.lineCounts.map(function (pbs)
                            {
                                pbs.stateCode = el.state.state.stateCode;
                                pbs.stateName = el.state.state.stateName;
                                stats.push(pbs);
                            });
                        }

                        el.setState({ txData: res });
                        el.plotPbs(stats);
                        if (res.groupCounts) el.plotAgeBand(res.groupCounts);
                    }

                }
                else
                {
                    if (res.groupCounts) el.plotAgeBand(res.groupCounts);
                }
            }
                           
        }
    }
    plotPbs(data) {
        let el = this;
        if (data.length > 0) {
            let categories: string[] = [];
            var males = [];
            var females = [];
            var total = [];

            data.map(function (d: any)
            {
                //@ts-ignore
                if (el.state.searchObj.siteId > 0)
                {
                   categories.push(d.siteName);
                }
                else
                {
                   categories.push(d.stateName);
                }

                males.push(d.aggregator1);
                females.push(d.aggregator2);
                total.push(d.total);
            });

            //Render HTS Results By State
            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'pbs',
                        type: 'column'
                    },
                    title: {
                        text: 'TX_PBS'
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: { categories: categories, type: 'category' },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Clients Captured'
                        },
                        labels: {
                            format: '{value}',
                            style: {
                                color: Highcharts.getOptions().colors[1]
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            shadow: false,
                            borderWidth: 0,
                        }
                    },
                    series: [
                        { name: 'Total Captured', data: total, type: 'column', pointPadding: 0 },
                        { name: 'Male', data: males, type: 'column', pointPadding: 0 },
                        { name: 'Female', data: females, type: 'column', pointPadding: 0 }
                    ]
                });
        }
    }
    plotPvls(data)
    {
        let el = this;
        if (data.length > 0)
        {
            let categories: string[] = [];
            var suppressed = [];
            var unsuppressed = [];
            var total = [];

            data.map(function (d: any)
            {
                //@ts-ignore
                if (el.state.searchObj.siteId > 0) {
                    categories.push(d.siteName);
                }
                else {
                    categories.push(d.stateName);
                }
                suppressed.push(d.aggregator1);
                unsuppressed.push(d.aggregator2);
                total.push(d.total);
            });

            //Render HTS Results By State
            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'pvls',
                        type: 'column'
                    },
                    title: {
                        text: 'TX_PVLS'
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: { categories: categories, type: 'category' },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Clients Tested'
                        },
                        labels: {
                            format: '{value}',
                            style: {
                                color: Highcharts.getOptions().colors[1]
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            shadow: false,
                            borderWidth: 0,
                        }
                    },
                    series: [
                        { name: 'Total Tested', data: total, type: 'column', pointPadding: 0 },
                        { name: 'Suppressed', data: suppressed, type: 'column', pointPadding: 0 },
                        { name: 'Unsuppressed', data: unsuppressed, type: 'column', pointPadding: 0 }
                    ]
                });
        }
    }
    plotHtsResult(data)
    {
        let el = this;
        if (data.length > 0) {
            let categories: string[] = [];
            var positives = [];
            var negatives = [];
            var totalTested = [];

            data.map(function (hts: any)
            {
                //@ts-ignore
                if (el.state.searchObj.siteId > 0) {
                    categories.push(hts.siteName);
                }
                else {
                    categories.push(hts.stateName);
                }
                positives.push(hts.positive);
                negatives.push(hts.negative);
                totalTested.push(hts.totalTested);
            });
           
            //Render HTS Results By State
            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'hts_results',
                        type: 'column'
                    },
                    title: {
                        text: 'HTS Results'
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: { categories: categories, type: 'category' },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Clients Tested'
                        },
                        labels: {
                            format: '{value}',
                            style: {
                                color: Highcharts.getOptions().colors[1]
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            shadow: false,
                            borderWidth: 0,
                        }
                    },
                    series: [
                        { name: 'Total Tested', data: totalTested, type: 'column', pointPadding: 0 },
                        { name: 'Negative', data: negatives, type: 'column', pointPadding: 0 },
                        { name: 'Positive', data: positives, type: 'column', pointPadding: 0 }
                    ]
                });

            el.plotHtsSession(data);
        }
    }
    plotHtsSession(data)
    {
        let el = this;
        if (data.length > 0) {
            let categories: string[] = [];
            var individuals = [];
            var couples = [];
            var previouslyselftested = [];

            data.map(function (hts: any)
            {
                //@ts-ignore
                if (el.state.searchObj.siteId > 0)
                {
                    categories.push(hts.siteName);
                }
                else {
                    categories.push(hts.stateName);
                }
                couples.push(hts.couple);
                previouslyselftested.push(hts.previouslyselftested);
                individuals.push(hts.individual);
            });

            //Render HTS Results By State
            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'hts_session',
                        type: 'column'
                    },
                    title: {
                        text: 'HTS Distribution By Session'
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: { categories: categories, type: 'category' },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Clients Tested'
                        },
                        labels: {
                            format: '{value}',
                            style: {
                                color: Highcharts.getOptions().colors[1]
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            shadow: false,
                            borderWidth: 0,
                        }
                    },
                    series: [
                        { name: 'Individual', data: individuals, type: 'column', pointPadding: 0 },
                        { name: 'Couple', data: couples, type: 'column', pointPadding: 0 },
                        { name: 'Previously self tested', data: previouslyselftested, type: 'column', pointPadding: 0 }
                    ]
                });

            el.plotHtsStat(data);
        }
    }
    plotHtsStat(data)
    {
        let el = this;
        if (data.length > 0)
        {
            let categories: string[] = [];
            var vct = [];
            var tb = [];
            var sti = [];
            var opd = [];
            var ward = [];
            var fp = [];
            var others = [];
            var standaloneHts = [];
            var communityArt = [];
            var outreach = [];
                     
            data.map(function (hts: any)
            {
                categories.push(hts.stateName);
                vct.push(hts.vct);
                tb.push(hts.tb);
                sti.push(hts.sti);
                opd.push(hts.opd);
                ward.push(hts.ward);
                fp.push(hts.fp);
                others.push(hts.others);
                standaloneHts.push(hts.standaloneHts);
                communityArt.push(hts.communityART);
                outreach.push(hts.outreach);
            });

            //Render HTS STAT By State
            Highcharts.chart(
            {
                chart:
                {
                    renderTo: 'hts_settings',
                    type: 'column'
                },
                title: {
                    text: 'HTS Distribution By Setting'
                },
                subtitle: {
                    text: ''
                },
                xAxis: { categories: categories, type: 'category' },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Clients Tested'
                    },
                    labels: {
                        format: '{value}',
                        style: {
                            color: Highcharts.getOptions().colors[1]
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                    pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        shadow: false,
                        borderWidth: 0,
                    }
                },
                series: [
                    { name: 'VCT', data: vct, type: 'column', pointPadding: 0 },
                    { name: 'TB', data: tb, type: 'column', pointPadding: 0 },
                    { name: 'STI', data: sti, type: 'column', pointPadding: 0 },
                    { name: 'OPD', data: opd, type: 'column', pointPadding: 0 },
                    { name: 'Ward', data: ward, type: 'column', pointPadding: 0 },
                    { name: 'FP', data: fp, type: 'column', pointPadding: 0 },
                    { name: 'Outreach', data: outreach, type: 'column', pointPadding: 0 },
                    { name: 'Standalone HTS', data: standaloneHts, type: 'column', pointPadding: 0 },
                    { name: 'Community Art', data: communityArt, type: 'column', pointPadding: 0 },
                    { name: 'Others', data: others, type: 'column', pointPadding: 0 }
                ]
            });
        }
    }
    plotPmtctHtsResult(data) {
        let el = this;
        if (data.length > 0) {
            let categories: string[] = [];
            var positives = [];
            var negatives = [];
            var totalTested = [];
            var labourAndDelivery = [];
            var postnatalWard = [];
            var anc = [];

            data.map(function (hts: any)
            {
                //@ts-ignore
                if (el.state.searchObj.siteId > 0)
                {
                    categories.push(hts.siteName);
                }
                else
                {
                    categories.push(hts.stateName);
                }
                positives.push(hts.positive);
                negatives.push(hts.negative);
                totalTested.push(hts.totalTested);
                labourAndDelivery.push(hts.labourAndDelivery);
                postnatalWard.push(hts.postnatalWard);
                anc.push(hts.anc);
            });

            //Render HTS Results By State
            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'pmtct_hts',
                        type: 'column'
                    },
                    title: {
                        text: 'HTS Results'
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: { categories: categories, type: 'category' },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Clients Tested'
                        },
                        labels: {
                            format: '{value}',
                            style: {
                                color: Highcharts.getOptions().colors[1]
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            shadow: false,
                            borderWidth: 0,
                        }
                    },
                    series: [
                        { name: 'Total Tested', data: totalTested, type: 'column', pointPadding: 0 },
                        { name: 'Negative', data: negatives, type: 'column', pointPadding: 0 },
                        { name: 'Positive', data: positives, type: 'column', pointPadding: 0 }
                    ]
                });

            el.plotPmtctEntryPoint(categories, totalTested, labourAndDelivery, postnatalWard, anc);
        }
    }
    plotPmtctEntryPoint(categories, totalTested, labourAndDelivery, postnatalWard, anc)
    {
        let el = this;
        if (categories.length > 0)
        {

            //Render HTS Results By State
            Highcharts.chart(
                {
                    chart:
                    {
                        renderTo: 'pmtct_hts_entry',
                        type: 'column'
                    },
                    title: {
                        text: 'PMTCT HTS Entry Point'
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: { categories: categories, type: 'category' },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Clients Tested'
                        },
                        labels: {
                            format: '{value}',
                            style: {
                                color: Highcharts.getOptions().colors[1]
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '<table style="width: 110px"><tr style="font-size:12px; font-weight: bold; border-bottom: thin solid #ddd"><td>{point.key}</td></tr>',
                        pointFormat: '<tr style="font-size:11px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:0"><b>{point.y}</b><br/></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    plotOptions: {
                        column: {
                            shadow: false,
                            borderWidth: 0,
                        }
                    },
                    series: [
                        { name: 'Total Tested', data: totalTested, type: 'column', pointPadding: 0 },
                        { name: 'Labour And Delivery', data: labourAndDelivery, type: 'column', pointPadding: 0 },
                        { name: 'Postnatal Ward', data: postnatalWard, type: 'column', pointPadding: 0 },
                        { name: 'ANC', data: anc, type: 'column', pointPadding: 0 }
                    ]
                });
        }
    }
    plotAgeBand(data)
    {
        let el = this;
        if (data.length > 0)
        {
            let males: number[] = [];
            let females: number[] = [];

            data.map(function (p: any)
            {
                if (p.gender.toLowerCase() === "female") females.push(-p.ageCount);
                if (p.gender.toLowerCase() === "male") males.push(p.ageCount);
            });

            var categories = [
                '0-4', '5-9', '10-14', '15-19',
                '20-24', '25-29', '30-34', '35-39', '40-44',
                '45-49', '50+ '
            ];

            var title = el.state.searchObj.indicator == 'TX_CURR_STAT' ? 'TX_CURR Disagrgregated by Age and Sex' : el.state.searchObj.indicator == 'TX_NEW_STAT' ?
                'TX_NEW Disagrgregated by Age and Sex' : el.state.searchObj.indicator == 'TX_PVLS_STAT' ? 'TX_PVLS Disagrgregated by Age and Sex' :
                    el.state.searchObj.indicator == 'TX_PBS_STAT' ? 'TX_PBS Disagrgregated by Age and Sex' : el.state.searchObj.indicator == 'PMTCT_ART_STAT' ? 'PMTCT_ART Disagrgregated by Age and Sex' : el.state.searchObj.indicator == 'PMTCT_STAT'? 'PMTCT_STAT Disagrgregated by Age and Sex' : 'HTS_INDEX_STAT';

            Highcharts.chart(
                {
                    chart: {
                        renderTo: 'band',
                        type: 'bar'
                    },
                    title:
                    {
                        useHTML: true,
                        text: title
                    },
                    subtitle: {
                        text: 'Active Clients (+28 Days)'
                    },
                    xAxis: [{
                        categories: categories,
                        reversed: false,
                        labels: {
                            step: 1
                        }
                    }, { // mirror axis on right side
                        opposite: true,
                        reversed: false,
                        categories: categories,
                        linkedTo: 0,
                        labels: {
                            step: 1
                        }
                    }],
                    yAxis: {
                        title: {
                            text: null
                        },
                        labels: {
                            formatter: function (val)
                            {
                                return Math.abs(parseFloat(val.value.toString())).toString();
                            }
                        }
                    },

                    plotOptions: {
                        series: {
                            stacking: 'normal'
                        }
                    },

                    tooltip: {
                        formatter: function () {
                            let nmb: number = this.point.y !== undefined ? this.point.y : 0;
                            return '<b>' + this.series.name + ', age ' + this.point.category + '</b><br/>' +
                                'No. of Clients: ' + nmb !== undefined ? (Highcharts.numberFormat(Math.abs(nmb), 0)).toString() : '0';
                        }
                    },

                    series: [{
                        name: 'Male',
                        data: males,
                        type: 'bar'
                    }, {
                        name: 'Female',
                        data: females,
                        type: 'bar'
                    }]
                });
        }
    }

    render() 
    {
        const { state, loading, states, searchObj, fileUrl, activeTab, txData} = this.state;
        let user = this.props.appUser;
        let el = this;
        const mapStyles = {
            width: '100%',
            height: '100%'
        };
        
        return (
            <div style={{marginTop: '15px', padding: '20px'}}>
                <Helmet>
                    <title>CDR :: MER</title>
                </Helmet>    
                <div className="custom-filter-dropdown">      
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Monitoring, Evaluation and Reporting</h4>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xs={24} sm={12} md={12} lg={6} xl={6} className="ant-modal-footer si-ant card-container" style={{ paddingTop: '10px' }}>  
                            <Card className="ant-card-body pfs s-list">
                                <Row>
                                    <Col span={24}>
                                        <Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                              <Select className="circl-radius"
                                                    labelInValue
                                                    showSearch
                                                    optionFilterProp="children"
                                                    disabled={loading}
                                                    style={{ width: '100%' }}
                                                    //@ts-ignore
                                                    value={{ key: searchObj.indicator }}
                                                    placeholder="-- Select MER Indicator --"
                                                    filterOption={(input: any, option: any) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={(value) => this.selectIndicator(value)}
                                                > 
                                                    {activeTab == 1 && <Option key="" value="">-- Select Analytics Option --</Option>}
                                                    {activeTab == 1 && <Option key="TX_CURR_STAT" value="TX_CURR_STAT">TX_CURR</Option>}
                                                    {activeTab == 1 && <Option key="TX_NEW_STAT" value="TX_NEW_STAT">TX_NEW</Option>}
                                                    {activeTab == 1 && <Option key="TX_PVLS_STAT" value="TX_PVLS_STAT">TX_PVLS</Option>}
                                                    {activeTab == 1 && <Option key="LIMS_EMR" value="LIMS_EMR">LIMS-EMR</Option>}
                                                    {activeTab == 1 && <Option key="TX_PBS_STAT" value="TX_PBS_STAT">TX_PBS</Option>}
                                                    {activeTab == 1 && <Option key="HTS_STAT" value="HTS_STAT">HTS</Option>}
                                                    {activeTab == 1 && <Option key="PMTCT_HTS_STAT" value="PMTCT_HTS_STAT">PMTCT HTS</Option>}

                                                    {activeTab == 2 && <Option key="" value="">-- Select Line list Option --</Option>}
                                                    {activeTab == 2 && <Option key="LineList" value="LineList">Line List</Option>}    
                                                    {activeTab == 2 && <Option key="TX_NEW" value="TX_NEW">TX_NEW</Option>}
                                                    {activeTab == 2 && <Option key="TX_RTT" value="TX_RTT">TX_RTT</Option>}
                                                    {activeTab == 2 && <Option key="TX_3t" value="TX_3t">Multiple ARV Drug Pick ups (Within a period)</Option>}
                                                    {activeTab == 2 && <Option key="TX_ML" value="TX_ML">TX_ML</Option>}
                                                    {activeTab == 2 && <Option key="TX_PBS" value="TX_PBS">TX_PBS</Option>}
                                                    {activeTab == 2 && <Option key="HTS" value="HTS">HTS</Option>}
                                                    {activeTab == 2 && <Option key="EID" value="EID">EID</Option>}
                                                    {activeTab == 2 && <Option key="PMTCT_HTS" value="PMTCT_HTS">PMTCT HTS</Option>}
                                                    {activeTab == 2 && <Option key="GANC" value="GANC">G-ANC(PMTCT)</Option>}
                                                </Select>
                                            </Col>
                                        </Row>

                                        {!user.stateCode && < Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                <Select className="circl-radius"
                                                    labelInValue
                                                    showSearch
                                                    optionFilterProp="children"
                                                    disabled={loading}
                                                    //@ts-ignore
                                                    value={{ key: searchObj.stateId }}
                                                    style={{ width: '100%' }}
                                                    placeholder="Select State"
                                                    onChange={(value) => this.selectState(value)}
                                                >
                                                    <Option key={0} value={0}>-- Select State --</Option>
                                                    {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                                </Select>
                                            </Col>
                                        </Row>}
                                        < Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                <Select className="circl-radius"
                                                    labelInValue
                                                    showSearch
                                                    optionFilterProp="children"
                                                    disabled={loading}
                                                    style={{ width: '99%', float: 'right' }}
                                                    //@ts-ignore
                                                    value={{ key: searchObj.site }}
                                                    placeholder="Select Site"
                                                    onChange={(value) => this.selectSite(value)}
                                                >
                                                    <Option key={0} value={0}>-- Select Site --</Option>
                                                    {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                                </Select>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: '8px' }}>
                                            <Col span={24}>
                                                {(searchObj.indicator !== 'TX_CURR' && searchObj.indicator !== 'TX_CURR_STAT' && searchObj.indicator !== 'LineList' && searchObj.indicator !== '') && <RangePicker className="circl-radius"
                                                    //@ts-ignore
                                                    value={[searchObj.from.length > 0 ? moment(searchObj.from, "YYYY-MM-DD") : null, searchObj.to.length > 0 ? moment(searchObj.to, "YYYY-MM-DD") : null]}
                                                    allowClear={true} onChange={(a: any, b: any) => this.dateRangeChange(a, b)} disabled={loading}
                                                />}
                                                
                                                {(searchObj.indicator === 'TX_CURR' || searchObj.indicator === 'TX_CURR_STAT' || searchObj.indicator === 'LineList') && <DatePicker placeholder={'Get ' + searchObj.indicator + ' as at: '} className="circl-radius"
                                                    //@ts-ignore
                                                    value={searchObj.to.length > 0 ? moment(searchObj.to, "YYYY-MM-DD") : null} allowClear={true}
                                                    onChange={(a: any, b: any) => this.dateChange(a, b)} disabled={loading} />}
                                            </Col>
                                        </Row>
                                        <Row style={{ marginBottom: '8px' }} gutter={2}>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <Button type="default" disabled={loading} className="login-button reset mer-fetch" size="large" onClick={() => this.reset()}>
                                                    <ReloadOutlined /> Reset
                                            </Button>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                                <Button disabled={loading} className="login-button mer-fetch" loading={loading} type="primary" size="large" onClick={() => this.qQ()}>
                                                    {loading ? 'loading...' : 'Fetch Data'}
                                                </Button>
                                                <div style={{ display: 'none' }}>
                                                    <iframe src={fileUrl} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>                       
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={18} xl={18} className="ant-modal-footer si-ant card-container" style={{ paddingTop: '10px' }}>
                            <Card className="ant-card-body pfs s-list card-box">
                                <Tabs defaultActiveKey="1" onChange={(key) => this.setTab(key)} size='large'>
                                    <TabPane tab={<span> <LineChartOutlined /> Analytics </span> } key="1" >
                                        <Col span={24} className="stat-card">
                                             <Row className="sr row-30px-pad-10px-top">
                                                <Col xs={24} sm={12} md={12} lg={(searchObj.indicator == 'TX_CURR_STAT' || searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'LIMS_EMR') ? 6 : 8} xl={(searchObj.indicator == 'TX_CURR_STAT' || searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'LIMS_EMR') ? 6 : 8} className="stat-card">
                                                        <Card className="ant-card-body pfs s-list">
                                                            <div className="custom-image">
                                                            <h3 className="db-h3 db-h3-i">{String((searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'PMTCT_HTS_STAT') ? txData.tested : (searchObj.indicator == 'LIMS_EMR') ? txData.totalManifests: txData.total).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                            </div>
                                                            {/*<TeamOutlined className="db-i" />*/}
                                                            <svg className="bi bi-people db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.995-.944v-.002.002zM7.022 13h7.956a.274.274 0 00.014-.002l.008-.002c-.002-.264-.167-1.03-.76-1.72C13.688 10.629 12.718 10 11 10c-1.717 0-2.687.63-3.24 1.276-.593.69-.759 1.457-.76 1.72a1.05 1.05 0 00.022.004zm7.973.056v-.002.002zM11 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zM6.936 9.28a5.88 5.88 0 00-1.23-.247A7.35 7.35 0 005 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 015 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10c-1.668.02-2.615.64-3.16 1.276C1.163 11.97 1 12.739 1 13h3c0-1.045.323-2.086.92-3zM1.5 5.5a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4z" clipRule="evenodd" />
                                                            </svg>
                                                            <div className="custom-card" title="View more">
                                                            <h3> {searchObj.indicator == 'TX_CURR_STAT' ? 'TX_CURR(+28 days)' : searchObj.indicator == 'LIMS_EMR' ? 'Total Manifests' : 'Total Patients'} &nbsp;</h3>
                                                            </div>
                                                        </Card>
                                                </Col>         
                                                <Col xs={24} sm={12} md={12} lg={(searchObj.indicator == 'TX_CURR_STAT' || searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'LIMS_EMR') ? 6 : 8} xl={(searchObj.indicator == 'TX_CURR_STAT' || searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'LIMS_EMR') ? 6 : 8} className="stat-card">
                                                        <Card className="ant-card-body pfs s-list">
                                                            <div className="custom-image">
                                                            <h3 className="db-h3 db-h3-g">{String(searchObj.indicator == 'TX_PVLS_STAT' ? txData.suppressed : (searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'PMTCT_HTS_STAT') ? txData.positive : (searchObj.indicator == 'LIMS_EMR') ? txData.totalSamples: txData.males).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                            </div>
                                                            {/*<UsergroupAddOutlined className="db-i" />*/}
                                                            <svg className="bi bi-person-check db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm6.854.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.5.5 0 01.708-.708L12.5 7.793l2.646-2.647a.5.5 0 01.708 0z" clipRule="evenodd" />
                                                            </svg>
                                                            <div className="custom-card">
                                                            <h3>{searchObj.indicator == 'TX_PVLS_STAT' ? 'Total Suppressed' : (searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'PMTCT_HTS_STAT') ? 'Positive' : searchObj.indicator == 'LIMS_EMR' ? 'Total Samples' : 'Males' }&nbsp;</h3>
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                <Col xs={24} sm={12} md={12} lg={(searchObj.indicator == 'TX_CURR_STAT' || searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'LIMS_EMR') ? 6 : 8} xl={(searchObj.indicator == 'TX_CURR_STAT' || searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'LIMS_EMR') ? 6 : 8} className="stat-card">
                                                        <Card className="ant-card-body pfs s-list">
                                                            <div className="custom-image">
                                                            <h3 className="db-h3 db-h3-b">{String(searchObj.indicator == 'TX_PVLS_STAT' ? txData.unsuppressed : (searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'PMTCT_HTS_STAT') ? txData.negative : (searchObj.indicator == 'LIMS_EMR') ? txData.rejectedSamples : txData.females).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                            </div>
                                                            {/*<SolutionOutlined className="db-i" />*/}
                                                        <svg className="bi bi-person-check db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm6.854.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.5.5 0 01.708-.708L12.5 7.793l2.646-2.647a.5.5 0 01.708 0z" clipRule="evenodd" />
                                                        </svg>
                                                            <div className="custom-card" title="View more">
                                                            <h3>{searchObj.indicator == 'TX_PVLS_STAT' ? 'Total Unsuppressed' : (searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'PMTCT_HTS_STAT') ? 'Negative' : searchObj.indicator == 'LIMS_EMR' ? 'Rejected Samples' : 'Females'}&nbsp;</h3>
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                {(searchObj.indicator == 'TX_CURR_STAT' || searchObj.indicator == 'HTS_STAT' || searchObj.indicator == 'LIMS_EMR') && <Col xs={24} sm={12} md={12} lg={6} xl={6} className="stat-card">
                                                    <Card className="ant-card-body pfs s-list">
                                                        <div className="custom-image">
                                                            <h3 className="db-h3 db-h3-n">{String(searchObj.indicator == 'TX_CURR_STAT' ? txData.inactive : searchObj.indicator == 'LIMS_EMR' ? txData.samplesWithResult : txData.indexClients).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</h3>
                                                        </div>
                                                        {/*<CarryOutOutlined className="db-i"/>*/}
                                                        <svg className="bi bi-person-plus db-i" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM6 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0zm4.5 0a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1H13V5.5a.5.5 0 01.5-.5z" clipRule="evenodd" />
                                                            <path fillRule="evenodd" d="M13 7.5a.5.5 0 01.5-.5h2a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0v-2z" clipRule="evenodd" />
                                                        </svg>
                                                        <div className="custom-card">
                                                            <h3>{searchObj.indicator == 'TX_CURR_STAT' ? 'TX_CURR (+90 days)' : searchObj.indicator == 'LIMS_EMR' ? 'Samples with Result' : 'Index Clients'}</h3> 
                                                        </div>
                                                    </Card>
                                                </Col>}
                                                </Row>
                                            <div className="dashboard" style={{ backgroundColor: 'rgb(240, 242, 245, 0.15)' }}>
                                                <Row className="row-30px-pad-10px-top state-txcurr" >
                                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} id="hts_results"></Col>
                                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} id="hts_session"></Col>
                                                    <Col span={24} id="hts_settings"></Col>
                                                    <Col span={24} id="pvls"></Col>   
                                                    <Col span={24} id="pbs"></Col> 
                                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} id="pmtct_hts"></Col>
                                                    <Col xs={24} sm={24} md={24} lg={12} xl={12} id="pmtct_hts_entry"></Col>
                                                </Row>
                                                <Row className="row-30px-pad-10px-top top-20px state-txcurr">
                                                    <Col span={24} id="band"></Col>   
                                                </Row>
                                            </div>
                                        </Col>
                                    </TabPane>
                                    <TabPane tab={<span> <OrderedListOutlined /> Line lists </span>} key="2">
                                        <Col span={24} className="stat-card">
                                           
                                        </Col>
                                    </TabPane>
                                </Tabs>
                            </Card>                            
                        </Col>
                    </Row>
                    <br />
                    <br />
                    <Row>
                        <Col span={24}>
                            <h6 style={{ fontSize: '14px', fontWeight: 500 }}>Select an Indicator to fetch the underlying data.</h6>
                            <h6 style={{ fontSize: '14px', fontWeight: 500 }}>Date range is optional for Line List, TX_CURR, and TX_NEW but mandatory for other Indicators.</h6>
                        </Col>
                    </Row>  
                </div>                            
            </div>
        ) 
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Mer as any);

